import { useRef } from "react";
import "./Trusted_Communities.css";

// Swiper
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TrustedCommunitys } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const Trusted_Communities = () => {
  const swiperRef = useRef(null);
  const sliderData = [
    { id: 1, img: "/assets/images/home/trusted_communities/img-1.png" },
    { id: 2, img: "/assets/images/home/trusted_communities/img-2.png" },
    { id: 3, img: "/assets/images/home/trusted_communities/img-3.png" },
    { id: 4, img: "/assets/images/home/trusted_communities/img-1.png" },
    { id: 5, img: "/assets/images/home/trusted_communities/img-2.png" },
  ];


  const { IMG_URL } = useContext(Context);
  
    const [trusted, setTrusted] = useState([]);
  
    const getTrusted = async () => {
      const res = await TrustedCommunitys();
      if (res?.success) {
        setTrusted(res.data);
      }
    };
    useEffect(() => {
      getTrusted();
    }, []);


  //   const [swiperInstance, setSwiperInstance] = useState(null);
  //   const handleMainSliderClick = (direction) => {
  //   if (swiperInstance) {
  //     if (direction === "prev") {
  //       swiperInstance.slidePrev();
  //     } else if (direction === "next") {
  //       swiperInstance.slideNext();
  //     }
  //   }
  // };




  return (
    <section className="Trusted_Communities">
      <div className="container">
        <div className="Trusted_Communities_div">
          <div className="row align-items-center">
            <div className="col-lg-4 col-md-5">
              <div className="Trusted_Communities_text_holder">
                <p className="Trusted_Communities_title">Trusted</p>
                <p className="Trusted_Communities_span"> Across Communities</p>

                <p className="Trusted_Communities_text">
                  Chosen by residential, society, & commercial clients for clean
                  and dependable solar energy.
                </p>
              </div>
            </div>

            <div className="col-lg-8 col-md-7 swiper_holder">
              {/* Custom Navigation */}
              <div className="custom_nav">
                <button
                  className="nav_btn"
                  onClick={() => swiperRef.current?.slidePrev()}
                  // onClick={() => handleMainSliderClick("prev")}
                  type="button"
                >
                  <FontAwesomeIcon icon={faAngleLeft}  className="font_angle" />
                </button>

                <button
                  className="nav_btn right_angle_btn"
                  onClick={() => swiperRef.current?.slideNext()}
                  type="button"
                  // onClick={() => handleMainSliderClick("next")}
                >
                  <FontAwesomeIcon icon={faAngleRight} className="font_angle" />
                </button>
              </div>
              <Swiper
                modules={[Navigation]}
                spaceBetween={20}
                slidesPerView={4}
                navigation={true}
                 onSwiper={(swiper) => (swiperRef.current = swiper)}
                // onSwiper={(swiper) => setSwiperInstance(swiper)}
                loop={true}
                breakpoints={{
                  320: { slidesPerView: 2 },
                  576: { slidesPerView: 3 },
                  768: { slidesPerView: 2.2 },
                  1200: { slidesPerView: 4 },
                }}
                className="trustedSwiper"
              >
                {trusted.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="trusted_card">
                      <img
                        src={IDS?.IMG_URL + item?.image}
                        alt="community"
                        className="card_img"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trusted_Communities;
